import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sopi-content',
  templateUrl: './sopi-dockpanel-content.component.html',
  styleUrls: ['./sopi-dockpanel-content.component.scss'],
})
export class SopiDockpanelContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
